<template>
  <div>
    <Head title="Work Orders/Machining/consumptions" />
    <h1 class="mb-8 text-3xl font-bold">
      Work Orders/Machining/Consumptions
    </h1>
    <div class="flex items-center justify-between mb-6 mt-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date Created</th>
          <th class="pb-3 pt-3 px-3">WO Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3">Quantity</th>
          <th class="pb-3 pt-3 px-3">Team</th>
          <th class="pb-3 pt-3 px-3">Created By</th>
          <th class="pb-3 pt-3 px-3" colspan="2"></th>
        </tr>
        <tr v-for="work_order in work_orders.data" :key="work_order.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/machining/consumptions/create`" tabindex="-1">
              {{ work_order.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/machining/consumptions/create`" tabindex="-1">
              {{ work_order.wo_number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/machining/consumptions/create`" tabindex="-1">
              {{ work_order.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/machining/consumptions/create`" tabindex="-1">
              {{ work_order.quantity }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/machining/consumptions/create`" tabindex="-1">
              {{ work_order.issuance_team }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" :href="`/work-orders/${work_order.id}/machining/consumptions/create`" tabindex="-1">
              {{ work_order.user }}
            </Link>
          </td>
        </tr>
        <tr v-if="work_orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="work_orders.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Icon,
    SearchWithDateRange,
    DateRange,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    work_orders: Object,
    teams: Array,
  },
  data() {
    return {
      form: {
        dateValue: this.filters.dateValue,
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/work-orders/machining/consumptions', pickBy(this.form), {
          preserveState: true,
          preserveScroll: true,
          replace: true
        })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
